import { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from './Tooltip';
import Disabled from '@/components/shared/Disabled';

type ComingSoonTooltipProps = {
  disabled: boolean;
  children: ReactNode;
  className?: string;
};

const ComingSoonTooltip = ({
  disabled,
  children,
  className,
}: ComingSoonTooltipProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  if (!disabled) return <Fragment>{children}</Fragment>;

  return (
    <Tooltip text={t('availableSoon')} classNameContainer={className}>
      <Disabled>{children}</Disabled>
    </Tooltip>
  );
};

export default ComingSoonTooltip;
